import React, { useEffect } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import CardFormView from '../CardFormView';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { useDispatch } from 'react-redux';
import { PaymentTopHeader, PaymentOptionsContainer } from './styled';
import { HiddenHeader } from '../HiddenHeader';
import { getMopOnFile, yifteeInitialization } from '../../redux/MopOnFileState/MopOnFileState.actions';
import { DefaultMopView } from '../DefaultMopView';
import MopListView from '../MopListView';
import { ReviewMopView } from '../ReviewMopView';
import { useAppSelector } from '../../hooks/useAppSelector';
import { YifteeFullCoverageView } from '../YifteeFullCoverageView';
import GiftCode from '../GiftCode/GiftCode';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import MessageBox from '../MessageBox/MessageBox';
import { mopOnFileSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
export var PaymentViews = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var mode = _ref.mode,
    priceSummary = _ref.priceSummary,
    showHeading = _ref.showHeading,
    headingText = _ref.headingText,
    initialHeadingLevel = _ref.initialHeadingLevel,
    hostedFieldsService = _ref.hostedFieldsService,
    yifteeBalance = _ref.yifteeBalance,
    braintreeService = _ref.braintreeService,
    optimizelyClient = _ref.optimizelyClient;
  var payment = useAppSelector(paymentSelector);
  var mopOnFile = useAppSelector(mopOnFileSelector);
  var yifteeMop = mopOnFile.yifteeMop;
  var deviceDataLoaded = Boolean(payment.deviceData);
  var dispatch = useDispatch();
  useEffect(function () {
    dispatch(getMopOnFile({}));
  }, []);
  useEffect(function () {
    if (yifteeMop) dispatch(yifteeInitialization({}));
  }, [priceSummary]);
  var getPaymentViewsBody = function getPaymentViewsBody() {
    return /*#__PURE__*/React.createElement(PaymentOptionsContainer, {
      ref: ref,
      tabIndex: -1,
      "data-test": DataTestAttributes.PAYMENT_OPTIONS
    }, showHeading && headingText && /*#__PURE__*/React.createElement(PaymentTopHeader, {
      "data-test": DataTestAttributes.PAYMENT_FORM_HEADER,
      "aria-level": initialHeadingLevel
    }, headingText), /*#__PURE__*/React.createElement(HiddenHeader, {
      mode: mode
    }), /*#__PURE__*/React.createElement(MessageBox, null), mode === AppMode.YIFTEE_FULL_COVERAGE ? /*#__PURE__*/React.createElement(YifteeFullCoverageView, null) : /*#__PURE__*/React.createElement(React.Fragment, null, yifteeBalance > -1 && /*#__PURE__*/React.createElement(GiftCode, null), mode === AppMode.DEFAULT_MOP && /*#__PURE__*/React.createElement(DefaultMopView, {
      hostedFieldsService: hostedFieldsService
    }), mode === AppMode.REVIEW_MOP && /*#__PURE__*/React.createElement(ReviewMopView, {
      hostedFieldsService: hostedFieldsService
    }), mode === AppMode.LIST_MOPS && /*#__PURE__*/React.createElement(MopListView, {
      hostedFieldsService: hostedFieldsService
    }), (mode === AppMode.ADD || mode === AppMode.EDIT) && /*#__PURE__*/React.createElement(CardFormView, {
      clientInstance: (braintreeService === null || braintreeService === void 0 ? void 0 : braintreeService.clientInstance) || null,
      hostedFieldsService: hostedFieldsService,
      isEdit: mode == AppMode.EDIT
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      ,
      isHidden: !(mode === AppMode.ADD || mode === AppMode.EDIT),
      optimizelyClient: optimizelyClient
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, priceSummary && mode !== AppMode.LOADING && deviceDataLoaded ? getPaymentViewsBody() : /*#__PURE__*/React.createElement(LoadingIndicator, null));
});
export default /*#__PURE__*/React.memo(PaymentViews);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentViews/index.js
// module id = 4537
// module chunks = 11